import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../../generic/create-modal-toggle';
import { productShape } from '../../../prop-types';
import AddBookingEntryContainer from './AddBookingEntry.container';

function AddBookingEntryModal({ opportunityId, products, toggle, onSuccess }) {
  return (
    <>
      <ModalHeader toggle={toggle}>Create Entry</ModalHeader>
      <ModalBody>
        <AddBookingEntryContainer
          opportunityId={opportunityId}
          products={products}
          onSuccess={onSuccess}
        />
      </ModalBody>
    </>
  );
}

AddBookingEntryModal.propTypes = {
  opportunityId: number.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  onSuccess: func.isRequired,
  toggle: func.isRequired,
};

export default createModalToggle(
  'Create Entry',
  AddBookingEntryModal,
  { className: 'ml-2' },
  { size: 'lg' },
);
export { AddBookingEntryModal }; // for unit tests
